import { CreateAccountField } from './types'

interface CountryAgeRestriction {
  DEFAULT: number
  [key: string]: number
}

export const FieldAnalyticsLabels: Record<CreateAccountField, string> = {
  givenNames: 'First Name',
  otherGivenNames: 'Middle Name',
  countryCode: 'Country',
  mobile: 'Mobile',
  dateOfBirth: 'DOB',
  surname: 'Last Name',
  address1: 'Address',
  address2: 'Address',
  area2: 'Address',
  postcode: 'Address',
  state: 'Address',
  suburb: 'Address',
  address: 'Address',
}

export const CreateAccountAnalyticsFields = ['givenNames', 'otherGivenNames', 'surname', 'mobile', 'email', 'dateOfBirth']

export enum EmailInputError {
  InvalidEmailError,
  DuplicatedEmailError,
  EmptyEmailError,
  UnsupportedMerchantTradingCountry,
  UnknownEmailError,
  DuplicatedCashEmailError,
}

export const MINIMUM_AGE_RESTRICTION: {
  [key: string]: CountryAgeRestriction
} = {
  US: {
    DEFAULT: 18,
  },
  CA: {
    AB: 18,
    MB: 18,
    ON: 18,
    PE: 18,
    QC: 18,
    SK: 18,
    DEFAULT: 19,
  },
  DEFAULT_COUNTRY: {
    DEFAULT: 18,
  },
} as const

export const MAX_AGE_RESTRICTION = 105
